import {
  AdminApi,
  Configuration,
  RejectRequest,
  AcceptLoginRequest,
  AcceptConsentRequest,
} from '@ory/hydra-client'

import { BASE_HYDRA_ADMIN_URL } from '@src/utils'

const hydraAdminClient = new AdminApi(
  new Configuration({ basePath: BASE_HYDRA_ADMIN_URL() })
)

export const getLoginRequest = async (challenge: string) => {
  const response = await hydraAdminClient.getLoginRequest(challenge)
  return response
}

export const acceptLoginRequest = async (
  challenge: string,
  data: AcceptLoginRequest
) => {
  const response = await hydraAdminClient.acceptLoginRequest(challenge, data)
  return response
}

export const rejectLoginRequest = async (
  challenge: string,
  error: RejectRequest
) => {
  const response = await hydraAdminClient.rejectLoginRequest(challenge, error)
  return response
}

export const getConsentRequest = async (challenge: string) => {
  const response = await hydraAdminClient.getConsentRequest(challenge)
  return response
}

export const acceptConsentRequest = async (
  challenge: string,
  data: AcceptConsentRequest
) => {
  const response = await hydraAdminClient.acceptConsentRequest(challenge, data)
  return response
}

export const rejectConsentRequest = async (
  challenge: string,
  data: RejectRequest
) => {
  const response = await hydraAdminClient.rejectConsentRequest(challenge, data)
  return response
}
